export const Selectors = {
  PROMOTOOL: '#ig-promotool',
  PROMOTOOL_FORM: '#promoform',
  SECTION: '.tool-section',
  PRIZE_SELECTION: '#prize-selection',
  PRIZE: '.promotion-prize'
};

export const Settings = {
  AJAX_TYPE_NUM: 4300
};

export const PluginNames = {
  4300: 'tx_igpromotool_promotool'
};
